import stylesheet from './Select.scss?inline';
import {NXTInputField} from "./InputField";

export class NXTSelectInput extends NXTInputField {
    selectElement: HTMLSelectElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    protected renderControl(): HTMLElement {
        const container = document.createElement('div');
        container.classList.add('select')
        const select = document.createElement('select');
        this.cloneDefaultSlotContentIntoContainer(select);
        container.appendChild(select);
        select.addEventListener('change', (ev) => {
            this.dispatchEvent(new Event(ev.type, ev));
        });
        this.selectElement = select;
        return container;
    }

    public get value() {
        return this.selectElement?.value;
    }

}

customElements.define('nxt-select', NXTSelectInput);
